import createIcon from './hocs/createIcon';
var InstapaperIcon = createIcon({
    color: '#1F1F1F',
    networkName: 'instapaper',
    path: 'M35.688 43.012c0 2.425.361 2.785 3.912 3.056V48H24.401v-1.932c3.555-.27 3.912-.63 3.912-3.056V20.944c0-2.379-.36-2.785-3.912-3.056V16H39.6v1.888c-3.55.27-3.912.675-3.912 3.056v22.068h.001z',
});
export default InstapaperIcon;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-share/es/InstapaperIcon.js
// module id = 546
// module chunks = 1